import {
  Box,
  Divider,
  Paper,
  Select,
  Typography,
  Grid,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import React, { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import BackArrow from "../../assets/icons/BackArrow.svg";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Profile from "../../assets/images/Profile.png";
import Stack from "@mui/material/Stack";
import countries from "../../utils/CountryCodeData";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PhoneNumber from "libphonenumber-js";
import { toast } from "react-toastify";
import {
  setLoaderSaveButton,
  setLoaderUserAccountPasswordButton,
} from "../../redux/actions/userActions";
import ChangepasswordModel from "./changepassword";
import CircularProgress from "@mui/material/CircularProgress";
import {
  setIsOpenModelEditAccountPassword,
  updateAccountDetailsList,
} from "../../redux/actions/accountAction";

const AccountContent = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.user?.isLoading);

  const userData = useSelector((state) => state?.user?.userData);

  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );
  const accountDetailsData = useSelector(
    (state) => state?.account?.accountDetailsData
  );

  const [image, setImage] = useState(null);
  let fileInput;
  const [isImageChange, setIsImageChange] = useState(false);

  const phoneNumber = new PhoneNumber(String(accountDetailsData?.phone));
  const [CountryCodeValue, setCountryCodeValue] = useState("");

  const [AccountData, setAccountData] = useState({
    FirstName: "",
    LastName: "",
    PhoneNo: "",
    Email: "",
    RoleName: "",
    Profile_image: null,
  });

  useEffect(() => {
    setAccountData({
      FirstName: accountDetailsData?.first_name,
      LastName: accountDetailsData?.last_name,
      PhoneNo: phoneNumber?.nationalNumber,
      Email: accountDetailsData?.email,
      RoleName: userData?.role?.name,
      Profile_image: accountDetailsData?.profile_image,
    });
    setCountryCodeValue(phoneNumber?.countryCallingCode);

    setImage(accountDetailsData?.profile_image);
  }, [accountDetailsData]);

  const defaultCountry = countries.find(
    (country) => country.code === phoneNumber?.country
  );
  const handleChangeAccountData = (e) => {
    const { name, value } = e.target;
    setAccountData({ ...AccountData, [name]: value });
  };

  const handleChangeCountryCodeValue = (newValue) => {
    setCountryCodeValue(newValue?.phone);
  };

  const handleImageClick = () => {
    if (fileInput) {
      fileInput.click();
    }
  };
  console.log("skjgbvuil", image);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setIsImageChange(true);
    setAccountData({ ...AccountData, Profile_image: file });
    console.log("hdaislhfilsgj", file);
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imgDataUrl = e.target.result;
        setImage(imgDataUrl);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleSaveAccount = async (event) => {
    event.preventDefault();
    if (
      AccountData?.FirstName !== "" &&
      AccountData?.LastName !== "" &&
      AccountData?.Email !== "" &&
      CountryCodeValue !== undefined &&
      AccountData?.PhoneNo !== ""
    ) {
      const emailPattern =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (emailPattern.test(AccountData?.Email)) {
        dispatch(
          updateAccountDetailsList({
            first_name: AccountData?.FirstName,
            last_name: AccountData?.LastName,
            email: AccountData?.Email,
            phone: "+" + CountryCodeValue + AccountData?.PhoneNo,
            username:
              AccountData?.FirstName?.toLowerCase() +
              "." +
              AccountData?.LastName?.toLowerCase(),
            company_id: userData?.company_id,
            role_id: userData?.role_id,
            id: userData?.id,
            Profile_image: isImageChange ? AccountData?.Profile_image : null,
          })
        );
      } else {
        toast.error("Please enter valid Email ID");
      }
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  countries.sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    dispatch(setLoaderSaveButton(false));
    dispatch(setLoaderUserAccountPasswordButton(false));
    dispatch(setIsOpenModelEditAccountPassword(false));
  }, []);

  return (
    <>
      <ChangepasswordModel />

      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box>
              <Typography
                sx={{
                  ml: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Edit Profile
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />
        {isLoading ? (
          <Grid item xs={12}>
            <Stack
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "25rem",
              }}
            >
              <CircularProgress color="success" />
            </Stack>
          </Grid>
        ) : (
          <Box sx={{ padding: "25px" }}>
            <Grid container spacing={3} pt={3}>
              <Grid item xs={12} sm={4}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  p={3}
                >
                  <Box>
                    <Avatar
                      alt="User Profile"
                      src={image || Profile}
                      sx={{ width: 150, height: 150, cursor: "pointer" }}
                      onClick={handleImageClick}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                      ref={(input) => (fileInput = input)}
                    />
                  </Box>
                  <Box>
                    <Button
                      variant="outlined"
                      sx={{
                        color: "#26875C",
                        border: "1px solid #26875C",
                        borderColor: "#26875C",
                        backgroundColor: "FFFFFF",
                        borderRadius: "8px",
                        textTransform: "capitalize",
                        fontWeight: 600,
                        fontSize: "12px",
                        mt: 5,
                        ":hover": {
                          borderColor: "#26875C",
                          backgroundColor: "FFFFFF",
                        },
                      }}
                      onClick={() =>
                        dispatch(setIsOpenModelEditAccountPassword(true))
                      }
                    >
                      Change Password
                    </Button>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="First Name"
                      type="text"
                      name="FirstName"
                      value={AccountData?.FirstName}
                      onChange={handleChangeAccountData}
                      sx={{
                        width: "100%",
                        borderRadius: "10px",
                        backgroundColor: "#F3F6F9",
                        border: "none",
                        "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                          border: "0px solid #F3F6F9",
                          borderRadius: "10px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Last Name"
                      type="text"
                      name="LastName"
                      value={AccountData?.LastName}
                      onChange={handleChangeAccountData}
                      sx={{
                        width: "100%",
                        borderRadius: "10px",
                        backgroundColor: "#F3F6F9",
                        border: "none",
                        "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                          border: "0px solid #F3F6F9",
                          borderRadius: "10px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      id="country-select-demo"
                      options={countries}
                      defaultValue={defaultCountry}
                      onChange={(event, newValue) =>
                        handleChangeCountryCodeValue(newValue)
                      }
                      autoHighlight
                      getOptionLabel={(option) => "+" + option.phone}
                      filterOptions={(options, state) => {
                        // Filter based on option.label
                        return options.filter((option) =>
                          option.label
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        );
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                          key={option.label}
                        >
                          <img
                            loading="lazy"
                            width="20"
                            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                            alt=""
                          />
                          {option.label}
                          {/* ({option.code}) +{option.phone} */}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          sx={{
                            width: "100%",
                            borderRadius: "10px",
                            backgroundColor: "#F3F6F9",
                            border: "none",
                            "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                              border: "0px solid #F3F6F9",
                              borderRadius: "10px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                            "& .MuiAutocomplete-clearIndicator": {
                              display: "none",
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          placeholder="Select Country"
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password",
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Phone No"
                      type="text"
                      name="PhoneNo"
                      value={AccountData?.PhoneNo}
                      onChange={handleChangeAccountData}
                      sx={{
                        width: "100%",
                        borderRadius: "10px",
                        backgroundColor: "#F3F6F9",
                        border: "none",
                        "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                          border: "0px solid #F3F6F9",
                          borderRadius: "10px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Email"
                      type="text"
                      name="Email"
                      value={AccountData?.Email}
                      onChange={handleChangeAccountData}
                      sx={{
                        width: "100%",
                        borderRadius: "10px",
                        backgroundColor: "#F3F6F9",
                        border: "none",
                        "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                          border: "0px solid #F3F6F9",
                          borderRadius: "10px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      disabled
                      fullWidth
                      placeholder="Role Name"
                      type="text"
                      name="RoleName"
                      value={AccountData?.RoleName}
                      onChange={handleChangeAccountData}
                      sx={{
                        width: "100%",
                        borderRadius: "10px",
                        backgroundColor: "#F3F6F9",
                        border: "none",
                        "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                          border: "0px solid #F3F6F9",
                          borderRadius: "10px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    mt={3}
                  >
                    <LoadingButton
                      onClick={handleSaveAccount}
                      variant="outlined"
                      sx={{
                        fontSize: "15px",
                        fontWeight: 600,
                        borderColor: "#26875C",
                        width: "6rem",
                        backgroundColor: "FFFFFF",
                        padding: "6px 0px 4px 0px",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        color: "#26875C",
                        mr: "10px",
                        ":hover": {
                          borderColor: "#26875C",
                        },
                      }}
                      loading={isSaveButtonLoading}
                    >
                      Save
                    </LoadingButton>

                    {/* <Button
                      variant="outlined"
                      sx={{
                        fontSize: "15px",
                        fontWeight: 600,
                        borderColor: "#26875C",
                        width: "6rem",
                        backgroundColor: "#26875C",
                        padding: "6px 0px 4px 0px",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        color: "#FFFFFF",
                        mr: "10px",
                        ":hover": {
                          backgroundColor: "#26875C",
                          borderColor: "#26875C",
                        },
                      }}
                    >
                      Cancel
                    </Button> */}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        )}
      </Paper>
    </>
  );
};

export default AccountContent;
